const config = {
  __DEV__: false,
  API_BASEURL: "https://api2.msblabs.us/bd/",
  env: "staging",
  SITE_URL: "https://buda-staging.msblabs.us",
  requireAuth: false,
  LIBRARY_URL: "https://library.bdrc.io",
  TEMPLATES_BASE: "http://purl.bdrc.io/",
}

export default config
